(() => {
  const $ = (id) => document.getElementById(id);
  let tId;
  const toast = (msg) => { const t = $("toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); clearTimeout(tId); tId = setTimeout(() => t.classList.remove("show"), 2400); };
  // Store buttons: play the oil pour first, then open the store in a new tab.
  // The delay stays under Safari's ~1s user-gesture window so the new tab is not blocked.
  document.querySelectorAll("a.store, a.store-wa").forEach((a) => a.addEventListener("click", (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    dispatchEvent(new Event("tatvamazi:fill"));
    setTimeout(() => { const w = window.open(a.href, "_blank"); if (w) w.opener = null; else location.href = a.href; }, 800);
  }));
  const copy = $("copyMail");
  if (copy) copy.onclick = () => {
    const el = $("mail");
    const select = () => { const r = document.createRange(); r.selectNodeContents(el); const s = getSelection(); s.removeAllRanges(); s.addRange(r); toast("Email selected"); };
    try { navigator.clipboard.writeText(el.textContent).then(() => toast("Email copied"), select); } catch (e) { select(); }
  };

  // Quantity steppers
  document.querySelectorAll("[data-qty]").forEach((q) => {
    const input = q.querySelector("input");
    q.querySelectorAll("[data-step]").forEach((b) => b.addEventListener("click", () => {
      const n = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10)));
      input.value = n;
    }));
  });

  // Add to cart without leaving the page. "Buy now" (name=return_to) submits normally and goes straight to checkout.
  // Without JavaScript every form still posts to /cart/add and lands on the cart.
  const setCount = (n) => document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = n; });
  document.querySelectorAll("form.js-add").forEach((form) => form.addEventListener("submit", async (e) => {
    if (e.submitter && e.submitter.name === "return_to") return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST", headers: { Accept: "application/json" }, body: new FormData(form)
      });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || "Could not add to cart"); }
      const cart = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js")).json();
      setCount(cart.item_count);
      dispatchEvent(new Event("tatvamazi:fill"));
      toast("Added to cart");
    } catch (err) {
      toast(err.message || "Could not add to cart");
    } finally {
      if (btn) btn.disabled = false;
    }
  }));

  // Product gallery thumbnails
  const main = $("gMain");
  if (main) document.querySelectorAll(".thumb").forEach((t) => t.addEventListener("click", () => {
    const img = main.querySelector("img");
    if (img) { img.removeAttribute("srcset"); img.src = t.dataset.src; }
    document.querySelectorAll(".thumb").forEach((x) => x.classList.toggle("is-on", x === t));
  }));
})();
